/*
 * Created on Sun Jun 02 2019
 *
 * Copyright (c) 2019 Sébastien Hecart - Fahbe Mobile App
 *
 *
 *
 */
export default {
  firebase: {
    'auth/wrong-password': 'Le mot de passe est incorrect.'
  }
}
